import React, { ComponentType, FunctionComponent } from 'react';
import { ObjectOf } from '../../types';
import ValidationOrdersDropzone from '../../components/ValidationOrdersDropzone';

/**
 * Injects the always-visible bulk-upload dropzone above the validation
 * orders list, outside react-admin's standard filter/action toolbar so it
 * stays visible even while filters are active.
 *
 * @param Component
 */
function withValidationOrdersDropzone(
  Component: ComponentType<any>
): FunctionComponent {
  const Extension: FunctionComponent<ObjectOf<any>> = (props) => (
    <div>
      <ValidationOrdersDropzone />
      <Component {...props} />
    </div>
  );

  Extension.displayName = 'withExtension(ValidationOrdersDropzone)';

  return Extension;
}

export default withValidationOrdersDropzone;
